import { APIFieldProps } from "../../features/actions/common/commonTypes";
import { useGetOAuthAuthorizationURIQuery } from "../../features/api";
import { ListItem } from "../List";
import Typography from "../text/Typography";
import React, {
    FunctionComponent,
    useCallback,
    useEffect,
    useState
} from "react";
import useOAuthCodeRequest from "../sharing/useOAuthCodeRequest";
import useActiveOrgData from "../../features/ontology/hooks/useActiveOrgData";
import {OAuthProvider} from "../sharing/types";
import {useLocation} from "react-router-dom";
import {
    initQueryStateTracker,
    QueryStateTracker
} from "../../features/api/helpers";


export const OAuthButton: FunctionComponent<APIFieldProps> = ({
        name,
        label
    }) => {

    const { activeItem: activeOrg } = useActiveOrgData();
    const location = useLocation();

	const [localFormState, setLocalFormState] = useState<QueryStateTracker>(
		initQueryStateTracker()
	);

    // const { data, isSuccess, isLoading, isFetching } = ;
    const {login, ...status} = useOAuthCodeRequest();

    const {data} = useGetOAuthAuthorizationURIQuery({ apix: name, orgId: activeOrg._id })


    // const connect = useCallback(
	// 	async (
	// 		{code, state, realmId, provider}: {provider: OAuthProvider, code: string, state?: string, realmId?: string}
	// 	) => {
	// 		try {
	// 			const body = {code, state, realmId, provider}
	// 			body.append('link', location.pathname + location.search);
	// 			connectApi({ provider, body });
	// 		} catch (e) {
	// 			return setLocalFormState((p) => ({
	// 				...p,
	// 				isError: true,
	// 				isLoading: false,
	// 				error: {
	// 					status: 400,
	// 					data: { message: e as string },
	// 				},
	// 			}));
	// 		}
	// 	},
	// 	[location.pathname, location.search]
	// );

	// const onSubmit: SubmitHandler = async (vals) => {
	// 	setLocalFormState((p) => ({
	// 		...p, isLoading: true, isUninitialized: false,
	// 	}));
	//
	// 	if (linkedInTokenValid) return doShare(vals);
	//
	// 	return token();
	//
	// 	// createShare({
	// 		// body: Object.assign({userId: user._id}, formVals),
	// 	// });
	// };

	// useEffect(() => {
	// 	if (status.isUninitialized) {
	// 		// if token was expired, the only way loginStatus could be in
	// 		// success state is if user initiated 'share' submission and
	// 		// completed the login flow If that's the case,
	// 		// submit the share to api server with code.
	// 		const body = {code, state, realmId, provider}
	// 		connectApi({ provider, body });
	// 	}
	// 	return null;
	// 	//  NB: we do NOT want this to re-run on form field changes.
	// }, [status.isUninitialized, login, code, state, realmId]);

	useEffect(() => {
		if (status.isSuccess) {
			// finally, if the 'share' request to api server is successful,
			// all loading is done and form should be in a success state.
			setLocalFormState((p) => ({
				...p,
				isSuccess: true,
				isError: false,
				isLoading: false,
				error: undefined,
			}));
		}
	}, [status.isSuccess]);


	return <ListItem
        button
        onClick={() => data && data.uri ? login(data.uri) : null}
            // if(data) {
            //     window.location.replace(data.data)
            // } else {
            //     return null
            // }
        // ref={setReferenceEl}
        style={{
            borderBottom: '1px solid #6a748550',
            margin: '0',
            padding: '4% 0 4% 16px',
            flexDirection: 'column',
            justifyItems: 'start',
            alignItems: 'start'
        }}
    >
        <Typography color='primary' variant={'caption2'}>
            Connect {name} API
        </Typography>
    </ListItem>
}

export default OAuthButton;
